import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';
import { StampDutyCalculator } from '@zoopla/stamp-duty-calculator';
import { FC } from 'react';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '../../../../ContentfulRenderOptions';
import { stampDutyWrapperInnerStyle } from './StampDutyWrapper.styles.css';

export const StampDutyWrapper: FC<
    React.PropsWithChildren<{ title: string; body: Document }>
> = ({ title, body }) => (
    <div className={stampDutyWrapperInnerStyle}>
        <StampDutyCalculator
            show={true}
            inputValue=""
            trackingCategory=""
            title={title}
            body={documentToReactComponents(body, CONTENTFUL_RICH_TEXT_OPTIONS)}
        />
    </div>
);
